import BillLading from '@/components/BillLading/BillLading';
export default {
    name: "sendBillApplyDetail",
	conditionData:'',
	created: function () {
      this.init();
	},
	components:{
		BillLading
	},
    data() {
        return {
			edit: false,
			showBillLading : true,
			showPdf :false,
			pdfSrc: '',
			numPages: 0,
			progress: 0,
			progressShow: true,
            billLadingData: {
                shipper: "shipper input text",
                consignee: "consignee input text",
                notifyParty: "notifyPart input text", ///
                placeOfreceipt: "placeOfreceipt input text",
                vessel: "vessel input text",
                portOfLoading: "portOfLoading input text",
                portOfTransshipment: "portOfTransshipment input text",
                PortOfDischarge: "portOfDischarge input text", ///
                PlaceOfDelivery: "placeOfDelivery input text", //
                freightCharges: "freightAndCharges input text", //
                NoOfOriginal: "noOfOriginal input text", //
                declared: "declared input text",
                voyageNo: "voyageNo input text",
                preCarriageBy: "carriageBy input text", //
                planceAndDate: "planceAndDate input text",
                forwardingAgent: "forAgent input text", //
                signedBy: "",
                typeOfMovement: "typeOfMovement input text",
                blNo: "billNo input text", //
				goodList:[],
				isAddtionalImageDisplay: ''
			},
			writeBillDetailForm: {
				signer:'',
				issuingParty_label:'',
				billFormatter:'',
				billType:'',
				billAdditionalDescription:'',
				billAdditionalDescriptionOfSend:'',
				billingFee:'',
				issuingTime:'',
				recFirstAuditResult:'',
				recFirstAuditOpinion:'',
				recFinalAuditResult:'',
				recFinalAuditOpinion:'',
				signAuditResult:'',
				signAuditOpinion:'',
				sendAuditResult:'',
				sendAuditOpinion:'',
				stdContainerNumber:'',
				portOfDischarge:'',
				payment:''
			},
			// 公司下拉列表
			companyList: [],
			imageType: 1,
			// 出单费下拉列表
			costList:[]
        }
	},
	computed: {
		singCompanyList(){
			if(this.writeBillDetailForm.issuingParty_label && this.writeBillDetailForm.signer){
				if(this.writeBillDetailForm.issuingParty_label === this.writeBillDetailForm.signer){
					const id = this.writeBillDetailForm.issuingParty_label;
					return [{id:id, companyName: this.getCompanyName(id)}]
				}else{
					const isId = this.writeBillDetailForm.issuingParty_label;
					const sid = this.writeBillDetailForm.signer;
					return [{id:isId, companyName: this.getCompanyName(isId)},
					{id:sid, companyName: this.getCompanyName(sid)}]
				}
			}
			return [];
		},
		billingFeeCompanyList(){
			let arr = [{
				id: this.conditionData.row.receiveCompanyId,
				companyName: this.conditionData.row.receiveCompanyName
			}];
			if(this.writeBillDetailForm.issuingParty_label && this.writeBillDetailForm.signer){
				if(this.writeBillDetailForm.issuingParty_label === this.writeBillDetailForm.signer){
					const id = this.writeBillDetailForm.issuingParty_label;
					arr.push(...[{id:id, companyName: this.getCompanyName(id)}]);
				}else{
					const isId = this.writeBillDetailForm.issuingParty_label;
					const sid = this.writeBillDetailForm.signer;
					arr.push(...[{id:isId, companyName: this.getCompanyName(isId)},
						{id:sid, companyName: this.getCompanyName(sid)}]);
				}
			}
			return arr;
		},
	},
    methods: {
        init(){
			// 取数据判断是走表单，还是PDF.修改showBillLading和showPdf(互斥)
			this.conditionData = this.$routerUtil.getParam();
			if(this.conditionData.row){
				this.billLadingData.shipper = this.conditionData.row.shipper;
				this.billLadingData.consignee = this.conditionData.row.consignee;
				this.billLadingData.notifyParty = this.conditionData.row.notifyParty;
				this.billLadingData.placeOfreceipt = this.conditionData.row.placeOfreceipt;
				this.billLadingData.vessel = this.conditionData.row.vessel;
				this.billLadingData.portOfLoading = this.conditionData.row.portOfLoading;
				this.billLadingData.portOfTransshipment = this.conditionData.row.portOfTransshipment;
				this.billLadingData.PortOfDischarge = this.conditionData.row.PortOfDischarge;
				this.billLadingData.PlaceOfDelivery = this.conditionData.row.PlaceOfDelivery;
				this.billLadingData.freightCharges = this.conditionData.row.freightCharges;
				this.billLadingData.NoOfOriginal = this.conditionData.row.NoOfOriginal;
				this.billLadingData.declared = this.conditionData.row.declared;
				this.billLadingData.voyageNo = this.conditionData.row.voyageNo;
				this.billLadingData.preCarriageBy = this.conditionData.row.preCarriageBy;
				this.billLadingData.planceAndDate = this.conditionData.row.planceAndDate;
				this.billLadingData.forwardingAgent = this.conditionData.row.forwardingAgent;
				this.billLadingData.signedBy = this.conditionData.row.signedBy;
				this.billLadingData.typeOfMovement = this.conditionData.row.typeOfMovement;
				this.billLadingData.blNo = this.conditionData.row.blNo;
				this.billLadingData.finalDestination = this.conditionData.row.finalDestination;
				this.billLadingData.totalNumber = this.conditionData.row.totalNumber;
				this.billLadingData.goodList = this.conditionData.row.billGoods;
				this.billLadingData.isAddtionalImageDisplay = this.conditionData.row.isAddtionalImageDisplay;
				this.writeBillDetailForm.signer = this.conditionData.row.signatureCompanyId;
				this.writeBillDetailForm.issuingParty_label = this.conditionData.row.sendCompanyId;
				this.writeBillDetailForm.billingFee = this.conditionData.row.sendBillFeeCompanyId;
				this.writeBillDetailForm.issuingTime = this.conditionData.row.sendBillDate;
				this.writeBillDetailForm.portOfDischarge = this.conditionData.row.costId;
				this.writeBillDetailForm.billFormatter = this.conditionData.row.billFormatter;
				this.writeBillDetailForm.billType = this.conditionData.row.billType;
				this.writeBillDetailForm.billAdditionalDescription = this.conditionData.row.billAdditionalDescription;
				this.writeBillDetailForm.billAdditionalDescriptionOfSend = this.conditionData.row.billAdditionalDescriptionOfSend;
				this.writeBillDetailForm.recFirstAuditResult = this.conditionData.row.rcfAuditResult;
				this.writeBillDetailForm.recFirstAuditOpinion = this.conditionData.row.rcfAuditOpinion;
				this.writeBillDetailForm.recFinalAuditResult = this.conditionData.row.rcsAuditResult;
				this.writeBillDetailForm.recFinalAuditOpinion = this.conditionData.row.rcsAuditOpinion;
				// 补充逻辑  如果签章公司和出单公司为同一家公司则审核意见显示出单方的、否则各自显示
				if (this.conditionData.row.sendCompanyId === this.conditionData.row.signatureCompanyId) {
					this.writeBillDetailForm.signAuditResult = this.conditionData.row.scfAuditResult;
					this.writeBillDetailForm.signAuditOpinion = this.conditionData.row.scfAuditOpinion;
				} else {
					this.writeBillDetailForm.signAuditResult = this.conditionData.row.signatureAuditResult;
					this.writeBillDetailForm.signAuditOpinion = this.conditionData.row.signatureAuditOpinion;
				}
				// this.writeBillDetailForm.signAuditResult = this.conditionData.row.signAuditResult;
				// this.writeBillDetailForm.signAuditOpinion = this.conditionData.row.signAuditOpinion;
				this.writeBillDetailForm.sendAuditResult = this.conditionData.row.scfAuditResult;
				this.writeBillDetailForm.sendAuditOpinion = this.conditionData.row.scfAuditOpinion;
				this.writeBillDetailForm.stdContainerNumber = this.conditionData.row.stdContainerNumber;
				this.writeBillDetailForm.payment = parseInt(this.conditionData.row.payType) ? parseInt(this.conditionData.row.payType) : null;
				// 如果不是wiffa
				if(this.conditionData.row.billImageName !== 'bill_image_wiffa.png'){
					this.imageType = 2;
				}
			}
			// 查询当前提单中的收单公司建立合作关系的出单公司下拉列表
			const selectSendCompanyParam = {};
			selectSendCompanyParam.receiveCompanyId = this.conditionData.row.receiveCompanyId;
			this.$axios({
				method: "get",
				url: "api/customerCompay/selecCompayCustomer", 
				params: selectSendCompanyParam
				}).then(res => {
					this.companyList = res.data.resultData;
				}).catch(error => {
					console.log(error);
					this.$message({
						message: this.$t('common.message.operateFail'),
						type: 'error',
						center: true
					});
				}); 
			// 查询出单费集合下拉
			const param = {};
			// param.isDefault = 0;
			this.$axios.get('/api/cost/selectCostIsDefault',{params:param}).then(response => {
				this.costList = response.data.resultData;
			}).catch(e => {
				console.log(e);
				this.$message({
					message: this.$t('common.message.operateFail'),
					type: 'error',
					center: true
				});
			});
		},
		doBack(){
			this.$routerUtil.setParam(this.conditionData.searchForm);
			this.$router.push('SendBillApplyManage');
		},
		getNowFormatDate() {
			const date = new Date();
			const seperator1 = "-";
			const seperator2 = ":";
			let month = date.getMonth() + 1;
			let strDate = date.getDate();
			if (month >= 1 && month <= 9) {
				month = "0" + month;
			}
			if (strDate >= 0 && strDate <= 9) {
				strDate = "0" + strDate;
			}
			return date.getFullYear() + seperator1 + month + seperator1 + strDate
			+ " " + date.getHours() + seperator2 + date.getMinutes()
			+ seperator2 + date.getSeconds();
		},
		getCompanyName(id){
			let companyName = '';
			this.companyList.forEach(item => {
				if(id === item.id){
					companyName = item.companyName;
				}
			});
			return companyName;
		}
    }
}
